export default __webpack_public_path__ + "static/lloyds-4250776da7d2a3f48c15d397e604c641.mp4";